<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link :to="{ name: 'EXCMRegionList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMRegionForm
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations" />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMRegionForm from './Form'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('excmregion/create')

export default {
  components: {
    EXCMRegionForm,
    Loader
  },

  data () {
    return {
      item: {
        regionUserData: [],
        idCoordinator: null
      }
    }
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ])
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      this.$router.push({ name: 'EXCMRegionUpdate', params: { id: created['@id'] } })
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
